<div class="about-container">
</div>
<div class="md-cell mdl-cell--12-col mdl-cell--hide-phone mdl-cell--hide-tablet">
    <div class="about">
        <div class="about-content">
            <h1 class="about-title">{{'ABOUT_US_TITLE' | translate}}</h1>
            <div class="about-central">
                <div class="about-first">
                    <div class="about-first--img">
                        <img src="./assets/images/about-2.jpg">
                    </div>
                    <div class="about-first--text">
                        <h2 class="about-sub">{{'ABOUT_US_S1' | translate}}</h2>
                        <p class="about-sub-parag">{{'ABOUT_US_C1' | translate}}</p>
                    </div>
                </div>
                <div class="about-second about-mg">
                    <div class="about-second--text">
                        <h2 class="about-sub">{{'ABOUT_US_S2' | translate}}</h2>
                        <p class="about-sub-parag">{{'ABOUT_US_C2_1' | translate}}</p>
                        <p class="about-sub-parag">{{'ABOUT_US_C2_2' | translate}}</p>
                        <p class="about-sub-parag">{{'ABOUT_US_C2_3' | translate}}</p>
                    </div>
                    <div class="about-second--img">
                        <img src="./assets/images/about-1.jpg">
                        <img src="./assets/images/about-3.jpg">
                    </div>
                </div>
                <div class="about-third about-mg">
                    <div class="about-third--img">
                        <img src="./assets/images/about-4.jpg">
                    </div>
                    <div class="about-third--text">
                        <h2 class="about-sub"> {{'ABOUT_US_S3' | translate}}</h2>
                        <p class="about-sub-parag">{{'ABOUT_US_C3_1' | translate}}</p>
                        <p class="about-sub-parag">{{'ABOUT_US_C3_2' | translate}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="mdl-cell--hide-desktop">
    <div class="about">
        <div class="about-head--margin">
            <h1 class="about-title">{{'ABOUT_US_TITLE' | translate}}</h1>
        </div>
        <div>
            <img class="img-phone" src="/assets/images/about-2.jpg" alt="Test">
        </div>
        <div class="about-head--margin">
            <h2 class="about-sub">{{'ABOUT_US_S1' | translate}}</h2>
            <p class="about-sub-parag">{{'ABOUT_US_C1' | translate}}</p>
        </div>
        <div>
            <img class="img-phone" src="/assets/images/about-1.jpg" alt="Test">
        </div>
        <div class="about-head--margin">
            <h2 class="about-sub">{{'ABOUT_US_S2' | translate}}</h2>
            <p class="about-sub-parag">{{'ABOUT_US_C2_1' | translate}}</p>
            <p class="about-sub-parag">{{'ABOUT_US_C2_2' | translate}}</p>
            <p class="about-sub-parag">{{'ABOUT_US_C2_3' | translate}}</p>
        </div>
        <div>
            <img class="img-phone" src="/assets/images/about-4.jpg" alt="Test">
        </div>
        <div class="about-head--margin">
            <h2 class="about-sub"> {{'ABOUT_US_S3' | translate}}</h2>
            <p class="about-sub-parag">{{'ABOUT_US_C3_1' | translate}}</p>
            <p class="about-sub-parag">{{'ABOUT_US_C3_2' | translate}}</p>
            <p class="about-sub-parag">{{'ABOUT_US_C3_3' | translate}}</p>
        </div>
    </div>
</div>